/**
 * sectionEditorExtensions — Shared TipTap extension list for content sections.
 *
 * Used in two places:
 *   1. SectionBodyEditor (interactive editing)
 *   2. generateHTML() call in view mode (static HTML rendering)
 *
 * This ensures the same node/mark types are registered so generateHTML
 * can correctly render custom nodes like Figure, YouTube, and IframeEmbed.
 */

import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import { Figure } from '../BlogEditor/FigureExtension';
import { YouTube } from './YouTubeExtension';
import { IframeEmbed } from './IframeEmbedExtension';

/**
 * Returns the list of extensions needed to render section content.
 * Does NOT include Placeholder (that's editor-only).
 */
export function getSectionExtensions() {
  return [
    StarterKit,
    Figure,
    YouTube,
    IframeEmbed,
    Link.configure({
      openOnClick: true,
      HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' },
    }),
  ];
}
